import React from 'react';
import * as styles from '../../DataExtractionTemplate.module.scss';
import { Popover, PopoverContent, PopoverTrigger, Text } from 'components/core';

const InterventionsPopoversList = () => {
  return (
    <div className={styles.ExtractionHeadingSubtext}>
      <Popover
        closeOnBlur={true}
        closeOnEscape={false}
        renderCloseButton={false}
      >
        <Text component="span">
          Add the main{' '}
          <PopoverTrigger>
            <Text component="span" className={styles.PopoverTrigger}>
              interventions
            </Text>
          </PopoverTrigger>
          ,{' '}
        </Text>
        <PopoverContent
          aria-label="Interventions"
          className={styles.PopoverContentText}
        >
          <Text>
            Interventions can be drugs, treatments or therapies, medication,
            physical therapy, surgical procedures, lifestyle changes, policies,
            etc.
          </Text>
          <Text>
            <strong>Examples</strong>: Educational programmes, hydrotherapy, hip
            replacement, a particular drug.
          </Text>
        </PopoverContent>
      </Popover>
      <Popover closeOnBlur={true} renderCloseButton={false}>
        <Text component="span">
          <PopoverTrigger>
            <Text component="span" className={styles.PopoverTrigger}>
              comparators
            </Text>
          </PopoverTrigger>
          ,{' '}
        </Text>
        <PopoverContent
          aria-label="Comparators"
          className={styles.PopoverContentText}
        >
          <Text>
            Comparator is the standard or reference point against which the
            intervention or exposure is being evaluated.
          </Text>
          <Text>
            <strong>Examples</strong>: control, placebo, usual treatment, usual
            care, no treatment, different treatment.
          </Text>
        </PopoverContent>
      </Popover>
      <Popover closeOnBlur={true} renderCloseButton={false}>
        <Text component="span">
          <PopoverTrigger>
            <Text component="span" className={styles.PopoverTrigger}>
              exposures
            </Text>
          </PopoverTrigger>
          {' or '}
        </Text>
        <PopoverContent
          aria-label="Exposures"
          className={styles.PopoverContentText}
        >
          <Text>
            Exposures can be lifestyle factors, risk factors, population factors
            etc. Evaluating exposures can help in determining the cause and
            treatment of particular outcomes.
          </Text>
          <Text>
            <strong>Examples</strong>: smoking, air pollution, a particular
            drug, treatment or therapy.
          </Text>
        </PopoverContent>
      </Popover>
      <Popover closeOnBlur={true} renderCloseButton={false}>
        <Text component="span">
          <PopoverTrigger>
            <Text component="span" className={styles.PopoverTrigger}>
              phenomena of interest
            </Text>
          </PopoverTrigger>{' '}
          you want to collect, based on your protocol. When extracting data from
          each study, you can select which were reported and add study specific
          groups (arms).
        </Text>
        <PopoverContent
          aria-label="Phenomena of interest"
          className={styles.PopoverContentText}
        >
          <Text>
            Concepts or phenomena of interest is the topic of interest for your
            review question.
          </Text>
          <Text>
            <strong>Examples</strong>: travel, mindfulness, new policy, rest.
          </Text>
        </PopoverContent>
      </Popover>
    </div>
  );
};
export default InterventionsPopoversList;
